var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.1,19.79c2.96-2.96,7.77-2.96,10.74,0l5.37,5.37c2.96,2.96,2.96,7.77,0,10.74l-41.11,41.11c-1.59,1.59-3.62,2.67-5.82,3.11l-11.17,2.24c-1.25.25-2.53-.14-3.43-1.04s-1.29-2.19-1.04-3.43l2.24-11.17c.44-2.21,1.52-4.23,3.11-5.82l41.11-41.11ZM74.84,30.53l-5.37-5.37-2.69,2.68,5.37,5.37,2.68-2.69ZM66.79,38.58l-5.37-5.37-33.06,33.06c-.53.53-.89,1.21-1.04,1.94l-1.12,5.58,5.58-1.12c.74-.15,1.41-.51,1.94-1.04l33.06-33.06Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeEdit2);
export default __webpack_public_path__ + "static/media/acae_edit_2.135c642f.svg";
export { ForwardRef as ReactComponent };